import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'
import { useUpdateEffect } from 'react-use'
import { content } from '@/store/template/content'
import produce from 'immer'
import { RiCheckboxCircleLine } from 'react-icons/ri'
import {
  undoHistoryAction,
  undoHistoryActionCount,
} from '@/store/builder/history'
import { isBuilder } from '@/store/builder/store'
import Classnames from 'classnames'

// components
import Title from '@/components/onepager/sections/Title'

function MultiChoice({ id, contentID, sectionData, wrapperId }) {
  const [getContent, setContent] = useRecoilState(content(contentID))
  const isBuilderApp = useRecoilValue(isBuilder)
  const [getHistoryAction, setHistoryAction] = useRecoilState(undoHistoryAction)
  const [getHistoryActionCount, setHistoryActionCount] = useRecoilState(
    undoHistoryActionCount
  )

  // undoSystem -- Content System
  useUpdateEffect(async () => {
    if (isBuilderApp) {
      if (!getHistoryAction) {
        setHistoryActionCount(getHistoryActionCount + 1)
      } else {
        setHistoryAction(false)
      }
    }
  }, [getContent])

  const setSelectedOption = option => {
    // getContent === option
    const nextState = produce(getContent, draft => {
      if (draft.selected == option) {
        draft.selected = ''
      } else {
        draft.selected = option
      }
    })
    setContent(nextState)
  }

  return (
    <div>
      <Title
        id={id}
        title={sectionData.title}
        prompt={sectionData.prompt}
        wrapperId={wrapperId}
      />

      <div className="boxBody">
        <div className={`grid grid-cols-${sectionData.data.cols} gap-3`}>
          {sectionData.data.choices.map((option, index) => (
            <div
              key={index}
              onClick={() => {
                setSelectedOption(option.text)
              }}
              className={Classnames(
                `py-3 px-5 pr-4 flex items-center justify-between multiChoiceButton text-lg font-medium cursor-pointer border-2  rounded `,
                {
                  'bg-gray-600 multiChoiceButtonSelected ring-gray-100 border-gray-600 text-border-gray-600 hover:bg-border-gray-600 ':
                    getContent.selected === option.text &&
                    sectionData.data.color.id == 'gray',
                  'ring-gray-100 multiChoiceButtonSelected border-gray-600 text-border-gray-600 hover:bg-border-gray-600 ':
                    sectionData.data.color.id == 'gray',
                  'bg-blue-500 multiChoiceButtonSelected ring-blue-100 border-blue-600 text-border-blue-600 hover:bg-border-blue-600':
                    getContent.selected === option.text &&
                    sectionData.data.color.id == 'blue',
                  'ring-blue-300 multiChoiceButtonSelected border-blue-600 text-border-blue-600 hover:bg-border-blue-600':
                    sectionData.data.color.id == 'blue',
                  'bg-green-500 multiChoiceButtonSelected ring-green-100 border-green-600 text-border-green-600 hover:bg-border-green-600':
                    getContent.selected === option.text &&
                    sectionData.data.color.id == 'green',
                  'ring-green-100 multiChoiceButtonSelected border-green-600 text-border-green-600 hover:bg-border-green-600':
                    sectionData.data.color.id == 'green',
                  'bg-purple-500 multiChoiceButtonSelected ring-purple-100 border-purple-600 text-border-purple-600 hover:bg-border-purple-600':
                    getContent.selected === option.text &&
                    sectionData.data.color.id == 'purple',
                  'ring-purple-100 multiChoiceButtonSelected border-purple-600 text-border-purple-600 hover:bg-border-purple-600':
                    sectionData.data.color.id == 'purple',
                  'bg-red-500 multiChoiceButtonSelected ring-red-100 border-red-600 text-border-red-600 hover:bg-border-red-600':
                    getContent.selected === option.text &&
                    sectionData.data.color.id == 'red',
                  'ring-red-100 border-red-600 text-border-red-600 hover:bg-border-red-600':
                    sectionData.data.color.id == 'red',
                  'bg-yellow-500 ring-yellow100 border-yellow-600 text-border-yellow-600 hover:bg-border-yellow-600':
                    getContent.selected === option.text &&
                    sectionData.data.color.id == 'yellow',
                  'ring-yellow-100 border-yellow-600 text-border-yellow-600 hover:bg-border-yellow-600':
                    sectionData.data.color.id == 'yellow',
                  selectedMultiOption: getContent.selected === option.text,
                }
              )}
            >
              <div className="flex-grow">{option.text}</div>
              {getContent.selected === option.text && (
                <div className="flex-shrink-0 text-white text-xl">
                  <RiCheckboxCircleLine />
                </div>
              )}
            </div>
          ))}

          {/* {getContent.selected} */}
        </div>
      </div>
    </div>
  )
}

export default MultiChoice
